import List from 'employees/auditLogs/List'
import Show from 'employees/auditLogs/Show'

export default {
  List,
  Show,
}
